import GridItem from "../../partials/gridItem";
import { serverUrl } from "../../config";
import { useNavigate } from "react-router";

export default function CompanyDirectoryItem(props) {
  function cleanString(inputString) {
    const cleanedString = inputString.replace(/&\s/g, "");

    return cleanedString;
  }
  const navigate = useNavigate();

  if (props.creator) {
    return (
      <GridItem
        xs={12}
        sm={6}
        lg={3}
        xl={3}
        xxl={2}
        itemClass="company-directory"
        bundle={props.item?.bundle}
        item={props?.item}
        id={props.item?.id}
        title={props.item?.title}
        // field_body={
        //   props.item?.summary ? props.item?.summary : props.item?.body
        // }
        category_label={props.item.category_labels}
        created={props.item?.created}
        hasImg={true}
        imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
        alt={`Poster for company directory ${props.item.id}`}
        cardActionArea={true}
        creator={props.creator}
        cardActionCallBack={
          props.creator
            ? () => {}
            : () => navigate(`/company_directory/view/${props.item?.id}`)
        }
        contentType={props.contentType}
        // shareEnabled
        route={"company_directory"}
        field_access_token={props.item.access_token}
        // sharePrompt={`This is a public link that enables you to share the event with your client, no login required.`}
      ></GridItem>
    );
  } else
    return (
      <>
        <GridItem
          xs={12}
          sm={6}
          itemClass="company-directory"
          bundle={props.item?.bundle}
          linkTo={true}
          viewLink={true}
          company_directory={true}
          route="company_directory"
          title={props.item.title}
          altStringAvatar={cleanString(props.item.title)}
          field_body={props.item.summary || props.item.body}
          user_picture={`${props.item.field_featured_image}`}
          textContainerCol={9}
          created={props.item.changed}
          nid={props.item.id}
          disableFavorites={true}
          disableFooterMargin={true}
          disableChip={true}
          hasAvatar={true}
          contentType={props.contentType}
        />
      </>
    );
}
